<template>
  <div class="component-container">
    <label v-if="showLabel()" :style="lableStyle"
      ><span class="xing" :style="required ? { color: '#f00' } : null">*</span
      >{{ label }}</label
    >
    <div :style="imgstyle">
      <div v-if="showMusic()" class="music-container" :style="musicFrameStyle">
        <!-- <el-tooltip :content="musicName" placement="top-start">
          <span class="music-name">{{ musicName }}</span>
        </el-tooltip> -->
        <el-tooltip
          v-if="playing"
          :content="tooltipForPause"
          placement="top-start"
        >
          <i class="el-icon-video-pause el-icon-action" @click="handlePause" />
        </el-tooltip>
        <el-tooltip v-else :content="tooltipForPlay" placement="top-start">
          <i class="el-icon-video-play el-icon-action" @click="handlePlay" />
        </el-tooltip>
        <el-tooltip
          :content="tooltipForDelete"
          placement="top-start"
          v-if="isedite"
        >
          <i class="el-icon-delete el-icon-action" @click="handleDelete" />
        </el-tooltip>
      </div>
      <el-tooltip
        v-else
        popper-class="image-tip"
        :disabled="disabledTooltip() || !isedite"
        :content="tooltip"
        placement="top-start"
      >
        <el-upload
          class="upload-btn"
          :style="uploadStyle"
          :action="uploadAction"
          :disabled="!isedite"
          :show-file-list="false"
          accept="audio/*"
          :on-success="handleUploadSuccess"
          :before-upload="handleBeforeUpload"
        >
          <div class="icon-wrap-container" :style="uploadStyle">
            <i class="el-icon-loading uploader-icon" v-if="musicloading" />
            <i class="el-icon-plus uploader-icon" v-else />
          </div>
        </el-upload>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import Validator from '../../utils/validator'

export default {
  name: 'jtMusic',
  props: {
    label: {
      type: String,
      default: '',
    },
    labelWidth: {
      type: String,
      default: '30%',
    },
    src: {
      type: String,
      default: '',
    },
    musicName: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '150px',
    },
    height: {
      type: String,
      default: '30px',
    },
    uploadAction: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      default: '',
    },
    supportTypes: {
      type: Array,
      default: () => ['audio/mpeg'],
    },
    supportSize: {
      type: Array,
      default: [5],
    },
    editable: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    alwaysEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lableStyle: {
        width: window.innerWidth > 768 ? this.labelWidth : '100%',
      },
      imgstyle: {
        width: window.innerWidth > 768 ? '500px' : '100%',
      },
      musicFrameStyle: {
        width: this.width,
        height: this.height,
      },
      uploadStyle: {
        width: this.width,
        height: this.height,
      },
      tooltipForPause: this.$t('music.PAUSE'),
      tooltipForPlay: this.$t('music.PLAY'),
      tooltipForDelete: this.$t('music.DELETE'),
      playing: false,
      audio: null,
      musicloading: false,
    }
  },
  computed: {
    isedite() {
      if (this.alwaysEdit) {
        return true
      } else {
        return this.editable
      }
    },
  },
  methods: {
    showLabel() {
      return !_.isEmpty(_.trim(this.label))
    },
    showMusic() {
      return !_.isEmpty(this.src)
    },
    disabledTooltip() {
      return _.isEmpty(_.trim(this.tooltip))
    },
    handleEndedEvent() {
      this.playing = false
    },
    handlePause() {
      if (this.playing) {
        this.playing = false
        this.audio.pause()
      }
    },
    handlePlay() {
      if (this.playing) {
        return
      }

      if (this.audio === null) {
        this.audio = new Audio()
        this.audio.addEventListener('ended', this.handleEndedEvent)
        this.audio.src = this.src
      }

      this.playing = true
      this.audio.play()
    },
    handleDelete() {
      const msg = this.$t('image.CONFIRM_FOR_DELETE')
      const title = this.$t('global.TIPS')
      this.$confirm(msg, title)
        .then(() => {
          this.videoloading = false
          this.handlePause()
          this.audio = null
          this.$emit('delete')
        })
        .catch(() => {})
    },
    handleUploadSuccess(response, file, fileList) {
      this.$emit('success', response.payload)
      this.musicloading = false
    },
    async handleBeforeUpload(file) {
      try {
        this._validate(file)
        this.musicloading = true
        return true
      } catch (err) {
        const title = this.$t('global.ERROR')
        await this.$alert(err.message, title, {
          type: 'error',
          showClose: false,
        })

        throw err
      }
    },
    _validate(file) {
      let errMsg = this.$t('music.SUPPORT_MUSIC_TYPE', {
        musicType: _.join(this.supportTypes),
      })
      Validator.isSupportFileType(file.type, this.supportTypes, errMsg)

      let errMsg1 = this.$t('music.SUPPORT_MUSIC_SIZE', {
        musicSize:
          this.supportSize.length === 2
            ? this.supportSize[1] / 1024 / 1024
            : this.supportSize[0] / 1024 / 1024,
      })
      let errMsg2 = this.$t('music.MIN_MUSIC_SIZE', {
        musicSize: this.supportSize[0] / 1024 / 1024,
      })
      Validator.isSupportFileSize(file.size, this.supportSize, errMsg1, errMsg2)
    },
  },
}
</script>

<style lang="stylus" scoped>
.component-container {
  display: flex;
  flex-direction: row;
  align-items: baseline;
}

.music-container {
  border: 1px dashed #333;
  padding: 5px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 22px
}

.music-name {
  width: 70%;
}

.el-icon-action {
  color: black;
  margin-left: 5px;
  cursor: pointer;
}

.upload-btn {
  border: 1px dashed #333;
}

.icon-wrap-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.uploader-icon {
  font-size: 28px;
  color: #333;
  cursor: pointer;
}

.image-tip {
  max-width: 200px;
}
</style>
